<template>
  <div class="taskStatusPopupsHost" aria-live="polite" aria-relevant="additions removals">
    <transition-group name="taskStatusPopup" tag="div" class="taskStatusPopupsHost__stack">
      <div
        v-for="it in items"
        :key="it.id"
        class="taskStatusPopup"
        :class="{
          taskStatusPopup_overdue: it.kind === 'overdue',
          taskStatusPopup_closedInTime: it.kind === 'closedInTime',
        }"
        role="status"
      >
        <div class="taskStatusPopup__bubble">
          <div class="taskStatusPopup__title">
            {{ content[it.kind].title }}
          </div>
          <div class="taskStatusPopup__text">
            {{ content[it.kind].text }}
          </div>
        </div>

        <div class="taskStatusPopup__avatar">
          <img :src="content[it.kind].imgSrc" alt="">
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useTaskStatusPopups } from './task-status-popups-store';

const { items, remove } = useTaskStatusPopups();

const content = {
  overdue: {
    title: 'Ох-ох-ох... Задача просрочена.',
    text: 'Галина Александровна слегка разочарована, но всё ещё верит в тебя 😔✊',
    imgSrc: '/images/2.png',
    ttlMs: 7000,
  },
  closedInTime: {
    title: 'Вот это дисциплина!',
    text: 'Задача закрыта вовремя.\nГалина Александровна гордится тобой 😊👍',
    imgSrc: '/images/1.png',
    ttlMs: 7000,
  },
} as const;

watch(
  () => items.value.map((x) => x.id),
  (ids, prevIds) => {
    const added = ids.filter((id) => !prevIds?.includes(id));
    for (const id of added) {
      const it = items.value.find((x) => x.id === id);
      if (!it) continue;
      const ttl = content[ it.kind ].ttlMs;
      window.setTimeout(() => remove(id), ttl);
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.taskStatusPopupsHost {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 9999;
  pointer-events: none;
}

.taskStatusPopupsHost__stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.taskStatusPopup {
  width: min(520px, calc(100vw - 32px));
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: end;
  column-gap: 12px;
}

.taskStatusPopup__bubble {
  border-radius: 14px;
  padding: 14px 16px;
  line-height: 1.25;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.14);
  position: relative;
  pointer-events: none;
}

.taskStatusPopup__bubble::after {
  content: '';
  position: absolute;
  right: -10px;
  bottom: 18px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.taskStatusPopup_overdue .taskStatusPopup__bubble {
  background: #FEE7E7;
  color: #111827;
}
.taskStatusPopup_overdue .taskStatusPopup__bubble::after {
  border-left: 10px solid #fbe7ea;
}

.taskStatusPopup_closedInTime .taskStatusPopup__bubble {
  background: #EEEEFD;
  color: #111827;
}
.taskStatusPopup_closedInTime .taskStatusPopup__bubble::after {
  border-left: 10px solid #e8ecff;
}

.taskStatusPopup__title {
  font-weight: 800;
  font-size: 18px;
  margin-bottom: 8px;
}

.taskStatusPopup__text {
  font-weight: 500;
  font-size: 16px;
  white-space: pre-line;
}

.taskStatusPopup__avatar {
  width: 80px;
  height: 80px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.04);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);

  img {
    object-fit: cover;
  }
}

.taskStatusPopup_overdue .taskStatusPopup__avatar {
  background-color: #FBC7C7;
}
.taskStatusPopup_closedInTime .taskStatusPopup__avatar {
  background-color: #D5D5F4;
}
.taskStatusPopup__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.taskStatusPopup-enter-active,
.taskStatusPopup-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}
.taskStatusPopup-enter-from,
.taskStatusPopup-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>

